import './debounce.js';
import './darkmode.js';
import './toggle-class.js';
import './sticky-navbar.js';
import './carousel.js';
import './scrollTo.js';
import './notification.js';
import './calendar_filters.js';
import './login-button.js';

import Filter from './filter';

function importAll(r) {
    r.keys().forEach(r);
}

let filters = document.getElementsByClassName('js-filter-nav');
if (filters.length) {
    let i;
    for (i = 0; i < filters.length; i++) {
        new Filter(filters[i]);
    }
}
